export default "__VITE_ASSET__D0CwV15R__"